<template>
  <div class="qrCodeBody">
    <Header />
    <div class="qrCodeMain" v-loading="loading">
      <Step :num='2' />
      <div class="qrCode">
        <div class="leftArea">
          <h2>扫码完成个人身份认证</h2>
          <div class="codeArea">
            <img :src="'data:image/png;base64,' + img">
            <dl v-if="isScanning">
              <dt><img src="@/assets/image/accomplish.png"></dt>
              <dd>扫码成功</dd>
            </dl>
          </div>
          <h5>请使用手机微信“扫一扫”<em @click="getCreateFaceUrl">刷新二维码</em></h5>
        </div>
        <div class="demonstration">
          <img src="@/assets/image/demonstration.png">
        </div>
      </div>
      <div class="lineBtn">
        <el-button size="mini" @click="getRoute">上一步</el-button>
        <!-- <el-button type="primary" size="mini">查询人脸识别结果 </el-button> -->
      </div>
    </div>
    <authResult :verifyMsg="verifyMsg" :face="face" v-show="authCompletedShow" @blockAuth="getBackStep" @blockFace="blockFace"></authResult>
  </div>
</template>

<script>
import authResult from './authResult.vue'
export default {
  data() {
    return {
      loading: false,
      face: false,
      authCompletedShow: false,
      verifyMsg: '',
      img: '',
      intervals: [],
      isScanning: false,
      orderNo: ''
      // infoForm: JSON.parse(sessionStorage.getItem('infoForm'))
    }
  },
  components: {
    authResult
  },
  mounted() {
    // this.intervals.push(
    // setInterval(() => {
    //   this.getAuthPersonStatus()
    // }, 3000)
    this.getCreateFaceUrl()
    // )
  },
  methods: {
    getRoute() {
      this.$router.push({ name: 'personEntryInfo' })
    },
    getBackStep() {
      this.countDown = 0
      this.$api
        .getBackStep({ flowId: this.$store.state.userInfo.flowId })
        .then(res => {
          if (res.code && res.code === '0') {
            this.$router.push({ name: 'personEntryInfo' })
          } else {
            return new Promise((resolve, reject) => {
              reject(res)
            })
          }
        })
        .catch(err => {
          if (err.code === '810404') {
            this.$alert(err.msg, '提示', {
              confirmButtonText: '好的',
              callback: () => {
                window.location.href = this.$store.state.userInfo.preWebUrl
              }
            })
          }
        })
    },
    getResult() {
      this.$alert('未查到人脸结果，请扫描二维码并完成人脸识别！', '提示', {
        confirmButtonText: '好的',
        type: 'warning'
      })
    },
    blockFace() {
      this.authCompletedShow = false
      this.getCreateFaceUrl()
    },
    getCreateFaceUrl() {
      this.loading = true
      this.clearInterval()
      this.$api
        .getPersonFace({ flowId: this.$store.state.userInfo.flowId })
        .then(res => {
          if (res.code && res.code === '0') {
            this.img = res.data.fileBytes
            this.orderNo = res.data.order
            this.isScanning = false
            this.intervals.push(
              setInterval(() => {
                this.getAuthPersonStatus()
              }, 3000)
            )
          } else {
            return new Promise((resolve, reject) => {
              reject(res)
            })
          }
          this.loading = false
        })
        .catch(err => {
          this.clearInterval()
          this.authCompletedShow = true
          this.face = true
          if (err.code === '6003') {
            this.face = false
          }
          this.verifyMsg = err.msg
          this.loading = false
        })
    },
    getAuthPersonStatus() {
      this.$api
        .checkVerifyStatus({ flowId: this.$store.state.userInfo.flowId })
        .then(res => {
          if (res.code && res.code === '0') {
            if (res.data.status === 'DOING') {
              this.isScanning = true
            } else if (res.data.status === 'PASSED') {
              this.clearInterval()
              // this.$emit('sendCode',{code: 3})
              this.$router.push({ name: 'authSuccess' })
            } else if (res.data.status === 'FAILED') {
              return new Promise((resolve, reject) => {
                reject(res)
              })
            }
          } else {
            return new Promise((resolve, reject) => {
              reject(res)
            })
          }
        })
        .catch(err => {
          this.clearInterval()
          this.authCompletedShow = true
          this.face = true
          if (err.code === '810403') {
            this.face = false
          }

          this.verifyMsg = err.msg
        })
    },
    clearInterval() {
      for (let i of this.intervals) {
        clearInterval(i)
      }
    }
  },
  destroyed() {
    this.clearInterval()
  }
}
</script>

<style lang="scss" scoped>
.qrCodeBody {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  height: 100%;
  background: #f1f3f7;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.qrCodeMain {
  width: 1600px;
  flex: 1;
  min-height: 650px;
  margin: 16px auto 0;
  background: #fff;
  padding: 0px 0 40px;
}
.qrCode {
  width: max-content;
  margin: 64px auto 0;
  display: flex;
}
.leftArea {
  text-align: center;
  h2 {
    font-size: 20px;
    font-weight: bold;
    color: #333333;
    line-height: 27px;
    letter-spacing: 1px;
  }
  h5 {
    margin-top: 14px;
    font-size: 14px;
    color: #595959;
    line-height: 19px;
    font-weight: normal;
  }
  em {
    color: #1c67f3;
    color: var(--main-bg-color);
  }
}
.codeArea {
  margin: 24px auto 0;
  width: 160px;
  height: 160px;
  position: relative;
  padding: 11px;
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid #dee0e7;
  img {
    width: 100%;
  }
  dl {
    width: 160px;
    height: 160px;
    position: absolute;
    top: -1px;
    left: -1px;
    background: rgba($color: #fff, $alpha: 0.7);
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  dt {
    width: 36px;
    margin: 0 auto;
  }
  dd {
    font-size: 16px;
    color: #333333;
    line-height: 21px;
    letter-spacing: 1px;
    margin-top: 4px;
  }
}
.demonstration {
  margin-top: 13px;
  width: 244px;
  height: 356px;
  margin-left: 135px;
  img {
    width: 100%;
  }
}
.lineBtn {
  width: 1600px;
  position: fixed;
  bottom: 0;
  border-top: 1px solid #eceef1;
  padding: 12px 0;
  text-align: center;
}
</style>